module.exports = __webpack_public_path__ + "img/website-06.0b67a74d.png";